import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SubscriptionDetailsDispatcher, SubscriptionDispatcher, SubscriptionEditDispatcher } from '@spaq/core';
import { SubscriptionDetailsStore } from '@spaq/core/stores/subscription-details-store';
import { SubscriptionEditStore } from '@spaq/core/stores/subscription-edit-store';
import { SubscriptionStore } from '@spaq/core/stores/subscription-store';
import {
	SUBSCRIPTION_DETAILS_DISPATCHER,
	SUBSCRIPTION_DETAILS_STORE,
	SUBSCRIPTION_DISPATCHER,
	SUBSCRIPTION_EDIT_DISPATCHER,
	SUBSCRIPTION_EDIT_STORE,
	SUBSCRIPTION_STORE
} from '@spaq/injection';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';
import {
	FieldsetPaymentsMethodComponent,
	SubscriptionAccessDocumentComponent,
	SubscriptionExtraInfosComponent,
	SubscriptionFormComponent,
	SubscriptionInfosComponent,
	SubscriptionInfosItemComponent,
	SubscriptionSelectPaymentComponent,
	UserInfosComponent
} from './components';
import { SubscriptionComponent, SubscriptionDetailsComponent, SubscriptionEditComponent } from './pages';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

@NgModule({
	imports: [SharedCommonModule, SharedComponentsModule, SharedCommonModule, DateInputsModule, SharedFormModule],
	declarations: [
		SubscriptionDetailsComponent,
		SubscriptionEditComponent,
		SubscriptionFormComponent,
		SubscriptionInfosComponent,
		SubscriptionInfosItemComponent,
		SubscriptionSelectPaymentComponent,
		FieldsetPaymentsMethodComponent,
		UserInfosComponent,
		SubscriptionExtraInfosComponent,
		SubscriptionAccessDocumentComponent,
		SubscriptionComponent
	],
	exports: [
		SubscriptionDetailsComponent,
		SubscriptionEditComponent,
		SubscriptionFormComponent,
		SubscriptionInfosComponent,
		SubscriptionInfosItemComponent,
		SubscriptionSelectPaymentComponent,
		FieldsetPaymentsMethodComponent,
		UserInfosComponent,
		SubscriptionExtraInfosComponent,
		SubscriptionAccessDocumentComponent,
		SubscriptionComponent,
		RouterModule
	]
})
export class SubscriptionModule {
	static forRoot(): ModuleWithProviders<SubscriptionModule> {
		return {
			ngModule: SubscriptionModule,
			providers: [
				{ provide: SUBSCRIPTION_DISPATCHER, useClass: SubscriptionDispatcher },
				{ provide: SUBSCRIPTION_EDIT_DISPATCHER, useClass: SubscriptionEditDispatcher },
				{ provide: SUBSCRIPTION_DETAILS_DISPATCHER, useClass: SubscriptionDetailsDispatcher },
				{ provide: SUBSCRIPTION_STORE, useClass: SubscriptionStore },
				{ provide: SUBSCRIPTION_EDIT_STORE, useClass: SubscriptionEditStore },
				{ provide: SUBSCRIPTION_DETAILS_STORE, useClass: SubscriptionDetailsStore }
			]
		};
	}
}
